export const formatDirectoryLeagueName = (name = "") => {
  return name
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const getDirectoryLeagueUrl = (league) => {
  return `/leagues/${formatDirectoryLeagueName(league.name)}-${league.id}`;
};